// extracted by mini-css-extract-plugin
module.exports = {"ValuesItems":"ValuesItems_ValuesItems__1vJhY"};